import React, { useState } from "react";
import "./ContactSection.css";

function ContactSection() {
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  return (
    <section className="contact-section">
      {/* Left Side Text */}
      <div className="contact-left">
        <h2>Need More Information?</h2>
        <p>Click the button to get in touch with us.</p>
      </div>

      {/* Right Side Button */}
      <div className="contact-right">
        <button onClick={togglePopup} className="contact-btn">
          Contact Us
        </button>
      </div>

      {/* Popup Form */}
      {isOpen && (
        <div className="popup-overlay">
          <div className="popup">
            <button className="close-btn" onClick={togglePopup}>×</button>
            <h3>Contact Form</h3>
            <form className="contact-form">
              <input type="text" placeholder="Your Name" required />
              <input type="email" placeholder="Your Email" required />
              <textarea placeholder="Your Message" rows="4" required></textarea>
              <button type="submit" className="submit-btn">Send</button>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}

export default ContactSection;
